<!-- displayedColumns: string[] = ['metaName', 'deviceName', 'deviceId', 'time', 'ledStellcode', 'blinkerIndicator', 'brightness', 'batteryVoltage', 'onlineStatus', 'duration'];
 -->
<table mat-table [dataSource]="dataSource!" class="mat-elevation-z8" matSort>
    <ng-container matColumnDef="metaName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Linienbeschriftung </th>
        <td mat-cell *matCellDef="let element"> {{element.metaName}} </td>
    </ng-container>
    <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Gerätename </th>
        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
    </ng-container>
    <ng-container matColumnDef="deviceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Geräte-Id </th>
        <td mat-cell *matCellDef="let element"> {{element.deviceId}} </td>
    </ng-container>
    <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Zeitstempel </th>
        <td mat-cell *matCellDef="let element"> {{element.time | date: 'dd.MM.yyyy - H:mm'}} </td>
    </ng-container>
    <ng-container matColumnDef="ledStellcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Stellzustand </th>
        <td mat-cell *matCellDef="let element"> {{element.ledStellcode}} | {{ element.ledIndicator}}</td>
    </ng-container>
    <ng-container matColumnDef="blinkerIndicator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Blinker </th>
        <td mat-cell *matCellDef="let element"> {{element.blinkerIndicator}} </td>
    </ng-container>
    <ng-container matColumnDef="brightness">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Helligkeit </th>
        <td mat-cell *matCellDef="let element"> {{element.brightness}} </td>
    </ng-container>
    <ng-container matColumnDef="batteryVoltage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Akkuspannung </th>
        <td mat-cell *matCellDef="let element"> {{element.batteryVoltage}} </td>
    </ng-container>
    <ng-container matColumnDef="onlineStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Online </th>
        <td mat-cell *matCellDef="let element"> {{element.onlineStatus}} </td>
    </ng-container>
    <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dauer </th>
        <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>